export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}course/material-submission`;

    return $resource(url, null, {
        get: {
            method: 'GET',
            url: `${url}/:guid`
        },
        update: {
            method: 'PUT',
            url: `${url}/update/:guid`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/MaterialSubmission/index.js